"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MultiGrid", {
  enumerable: true,
  get: function get() {
    return _MultiGrid["default"];
  }
});
exports["default"] = void 0;
var _MultiGrid = _interopRequireDefault(require("./MultiGrid"));
var _default = exports["default"] = _MultiGrid["default"];